(() => {
  const init = root => {
    if (!root || root.dataset.niihaiReady) return;
    root.dataset.niihaiReady = 'true';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const chapters = root.querySelectorAll('.bc-niihai__chapter');
    if ('IntersectionObserver' in window) {
      const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        reveal.unobserve(entry.target);
      }), {threshold:.12});
      chapters.forEach(chapter=>reveal.observe(chapter));
    } else chapters.forEach(chapter=>chapter.classList.add('is-in'));
    const points = [...root.querySelectorAll('[data-niihai-chart-point]')];
    const buttons = [...root.querySelectorAll('[data-niihai-chart-index]')];
    const formatRevenue = value => '£'+Math.floor(value/10000)*10+'K+';
    const coords = points.map((point,index)=>({x:25+index*600/(points.length-1),y:235-Number(point.dataset.value)/320000*210}));
    points.forEach((point,i)=>{point.setAttribute('cx',coords[i].x);point.setAttribute('cy',coords[i].y);});
    const path = coords.map((point,i)=>(i?'L':'M')+point.x.toFixed(2)+' '+point.y.toFixed(2)).join(' ');
    const line = root.querySelector('[data-niihai-chart-line]');
    if (line) {
      line.setAttribute('d',path);
      root.querySelector('[data-niihai-chart-area]').setAttribute('d',path+' L625 240 L25 240 Z');
      if (!motion.matches && 'IntersectionObserver' in window) {
        const draw = new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){const length=line.getTotalLength();line.animate([{strokeDasharray:length,strokeDashoffset:length},{strokeDasharray:length,strokeDashoffset:0}],{duration:1300,easing:'cubic-bezier(.4,0,.2,1)'});draw.disconnect();}},{threshold:.25});
        draw.observe(line);
      }
    }
    const select = index => {
      const point = points[index]; if (!point) return;
      root.querySelector('[data-niihai-chart-value]').textContent=formatRevenue(Number(point.dataset.value));
      const date = new Date(point.dataset.date+'T00:00:00Z');
      root.querySelector('[data-niihai-chart-month]').textContent=new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',year:'numeric',timeZone:'UTC'}).format(date);
      buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      points.forEach((item,i)=>{item.setAttribute('r',i===index?'6':'4');item.setAttribute('fill',i===index?'#7cffcb':'#181818');});
    };
    buttons.forEach((button,i)=>{const date=new Date(points[i].dataset.date+'T00:00:00Z');const label=new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',year:'numeric',timeZone:'UTC'}).format(date);button.setAttribute('aria-label',label+' · '+formatRevenue(Number(points[i].dataset.value)));button.querySelector('span').textContent=new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',timeZone:'UTC'}).format(date);button.addEventListener('click',()=>select(i));button.addEventListener('pointerenter',()=>select(i));button.addEventListener('focus',()=>select(i));});
    points.forEach((point,i)=>point.addEventListener('pointerenter',()=>select(i)));
    select(points.length-1);
    root.querySelectorAll('[data-niihai-funnel-view]').forEach(button=>button.addEventListener('click',()=>{
      const funnel=button.closest('[data-niihai-funnel]');
      funnel.classList.toggle('is-purchase',button.dataset.niihaiFunnelView==='purchase');
      funnel.querySelectorAll('[data-niihai-funnel-view]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
    }));
    const filters=[...root.querySelectorAll('[data-niihai-filter]')];
    filters.forEach(button=>button.addEventListener('click',()=>{
      const filter=button.dataset.niihaiFilter;
      filters.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      root.querySelectorAll('[data-niihai-format]').forEach(card=>{
        card.hidden=filter!=='all'&&card.dataset.niihaiFormat!==filter;
        if(card.hidden) card.querySelectorAll('video').forEach(video=>video.pause());
      });
      root.querySelector('.bc-niihai__creatives').scrollTo({left:0,behavior:motion.matches?'instant':'smooth'});
    }));
  };
  const mount = () => document.querySelectorAll('[data-niihai-story]').forEach(init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mount,{once:true}); else mount();
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-niihai-story]').forEach(init));
})();
